var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extraFields.building)?_c('text-field',{attrs:{"id":"building-field","validation":_vm.$v.building,"validationMessage":_vm.textRequired,"label":_vm.textLabel,"rest":{
    placeholder: _vm.placeholder
      ? _vm.textLabel
      : null,
  },"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},model:{value:(_vm.form.building),callback:function ($$v) {_vm.$set(_vm.form, "building", $$v)},expression:"form.building"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }